'use client';

import React, { useEffect, useState, useRef } from 'react';
import { AnimationContainer, AnimationFrame, AnimationImg, ErrorNumber } from './elements';
async function fetchImageBase64(imageSrc) {
  const response = await fetch(imageSrc);
  const blob = await response.blob();
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = function () {
      resolve(this.result);
    };
    reader.readAsDataURL(blob);
  });
}
function useInterval(fn, interval) {
  const intervalRef = useRef();
  const start = () => {
    intervalRef.current = window.setInterval(fn, interval);
  };
  const stop = () => {
    window.clearInterval(intervalRef.current);
  };
  return {
    start,
    stop
  };
}
export const Animation = ({
  animationSrc,
  animationFrames,
  transitionDuration,
  errorNumberSrc,
  imageSrc,
  imgAfterIdx = -1,
  altText,
  ...rest
}) => {
  const [assets, setAssets] = useState({
    frames: [],
    image: null,
    didLoad: false
  });
  const [active, setActive] = useState(0);
  const {
    start,
    stop
  } = useInterval(() => {
    setActive(curr => (curr + 1) % animationFrames);
  }, transitionDuration);
  useEffect(() => {
    // Load assets
    (async () => {
      const [image, ...frames] = await Promise.all([imageSrc && fetchImageBase64(imageSrc), ...[...Array(animationFrames)].map((_, i) => `${animationSrc}f${i + 1}.svg`).map(async url => {
        const res = await fetch(url);
        return await res.text();
      })]);
      setAssets({
        didLoad: true,
        image,
        frames
      });
      start();
    })().catch(() => {
      // Image failed to load
      // Do nothing
    });
    return stop;
  }, []);
  return /*#__PURE__*/React.createElement(AnimationContainer, rest, /*#__PURE__*/React.createElement(ErrorNumber, {
    src: errorNumberSrc,
    alt: altText
  }), assets.didLoad && assets.frames.map((svg, i) => /*#__PURE__*/React.createElement(AnimationFrame, {
    key: i,
    src: `data:image/svg+xml,${svg}`,
    alt: `${altText}-animation`,
    style: {
      opacity: active === i ? 1 : 0
    }
  })), imageSrc && assets.didLoad && /*#__PURE__*/React.createElement(AnimationImg, {
    role: "presentation",
    src: assets.image,
    style: {
      opacity: active > imgAfterIdx ? 1 : 0
    }
  }));
};